<template>
  <transition name="el-zoom-in-top">
    <div class="content-wrapper">
      <section class="content-header">
        <ol class="breadcrumb">
          <li>
            <router-link to="/">
              <i class="ti-home"></i>
            </router-link>
          </li>
          <li>
            <router-link :to="{ name: 'devices' }">Devices</router-link>
          </li>
          <li class="active">
            <a href="#">Add Device</a>
          </li>
        </ol>
      </section>
      <!-- Main content -->
      <section class="content device-content">
        <div class="box">
          <!-- <div class="box-header">
            <div class="box-tools pull-right">
              <button
                type="button"
                data-widget="collapse"
                data-toggle="tooltip"
                title="Collapse"
                class="btn btn-box-tool"
              ><i class="ti-minus"></i></button>
              <button
                type="button"
                data-widget="remove"
                data-toggle="tooltip"
                title="Remove"
                class="btn btn-box-tool"
              ><i class="ti-close"></i></button>
            </div>
          </div>-->
          <div class="box-body">
            <el-form
              :model="device"
              :rules="rules"
              ref="device"
              label-width="120px"
              label-position="top"
            >
              <el-row :gutter="20">
                <el-col :md="24" :lg="8">
                  <el-form-item label="Name" prop="name">
                    <el-input v-model="device.name"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :md="24" :lg="8">
                  <el-form-item label="Serial" prop="serial">
                    <el-input v-model="device.serial"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :md="24" :lg="8">
                  <el-form-item label="ICC Id" prop="iccId">
                    <el-input v-model="device.iccId"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20" v-if="isAdmin">
                <el-col :md="24" :lg="8">
                  <el-form-item label="Customer" prop="customer">
                    <el-select
                      v-model="device.customer.id"
                      placeholder="Please select customer"
                    >
                      <el-option
                        v-for="item in customers"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <hr />
              <el-form-item label="channels" prop="channels">
                <template slot="label">
                  channels
                  <el-button
                    type="success"
                    @click="addChannel"
                    icon="el-icon-plus"
                    size="mini"
                    >Add</el-button
                  >
                </template>
                <el-table :data="device.channels" style="width: 100%">
                  <template slot="empty">Loading...</template>
                  <el-table-column label="Name" prop="name">
                    <template scope="scope">
                      <el-form-item
                        :inline-message="true"
                        :prop="`channels.${scope.$index}.name`"
                        :rules="{
                          required: true,
                          message: 'Please input device channel name',
                          trigger: 'blur',
                        }"
                      >
                        <el-input
                          v-model="device.channels[scope.$index].name"
                        ></el-input>
                      </el-form-item>
                    </template>
                  </el-table-column>
                  <el-table-column label="Channel" prop="channelIndex">
                    <template scope="scope">
                      <el-form-item
                        :prop="`channels.${scope.$index}.channelIndex`"
                        :rules="{
                          type: 'number',
                          required: true,
                          message: 'Please input device channel index',
                          trigger: 'blur',
                        }"
                      >
                        <el-input-number
                          :min="0"
                          :max="10"
                          v-model="device.channels[scope.$index].channelIndex"
                        ></el-input-number>
                      </el-form-item>
                    </template>
                  </el-table-column>
                  <el-table-column align="right">
                    <template scope="scope">
                      <el-button
                        size="mini"
                        type="danger"
                        icon="el-icon-minus"
                        @click="handleRemove(scope.$index)"
                        :disabled="device.channels.length <= 1"
                        >Remove</el-button
                      >
                    </template>
                  </el-table-column>
                </el-table>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="submitForm('device')"
                  >Create</el-button
                >
                <el-button @click="resetForm('device')">Reset</el-button>
              </el-form-item>
            </el-form>
            <hr />
          </div>
          <!-- /.box-body -->
        </div>
      </section>
      <!-- /.content -->
    </div>
  </transition>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
// import { required, minLength, between } from 'vuelidate/lib/validators'
export default {
  name: "device-add",
  data() {
    return {
      customerName: "",
      device: {
        serial: "",
        name: "",
        iccId: "",
        customer: {},
        customerId: undefined,
        channels: [
          {
            name: "",
            channelIndex: 0,
          },
        ],
      },
    };
  },
  computed: {
    ...mapGetters({
      isAdmin: "account/isAdmin",
      customers: "customers/list",
    }),
    rules() {
      return {
        name: [
          {
            required: true,
            message: "Please input device name",
            trigger: "blur",
          },
          { min: 3, message: "Length should be more then 3", trigger: "blur" },
        ],
        serial: [
          {
            required: true,
            message: "Please input device serial",
            trigger: "blur",
          },
          { min: 4, message: "Length should be more then 4", trigger: "blur" },
        ],
        iccId: [
          {
            required: true,
            message: "Please input device ICC Id",
            trigger: "blur",
          },
          { min: 6, message: "Length should be more then 6", trigger: "blur" },
        ],
        ...(this.isAdmin
          ? {
              customerId: [
                {
                  type: "number",
                  required: true,
                  message: "Please select customer",
                  trigger: "blur",
                },
              ],
            }
          : {}),
      };
    },
  },
  methods: {
    ...mapActions({
      addDevice: "devices/addDevice",
      fetchCustomers: "customers/fetchCustomers",
    }),
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.addDevice(this.device).then((_) =>
            this.$router.push({ name: "devices" })
          );
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    addChannel() {
      this.device.channels.push({
        name: "",
        channelIndex: 0,
      });
    },
    handleRemove(index) {
      if (this.device.channels.length > 1) {
        this.device.channels.splice(index, 1);
      }
    },
  },
  created() {
    this.isAdmin && this.fetchCustomers();
  },
};
</script>



// WEBPACK FOOTER //
// Add.vue?ae472992